import type { Dispatch, FC, SetStateAction } from "react"
import React, { useState } from "react"
import { Button, Stack, Text, Checkbox, Link } from "@chakra-ui/react"

import GenericModal from "ui/components/GenericModal"

type ArbitrumComplianceNoteModalProps = {
  setDisplayArbitrumComplianceNote: Dispatch<SetStateAction<boolean>>
  displayArbitrumComplianceNote: boolean
  setAcceptedComplianceNote: Dispatch<SetStateAction<boolean>>
}

const ArbitrumComplianceNoteModal: FC<ArbitrumComplianceNoteModalProps> = ({
  setDisplayArbitrumComplianceNote,
  displayArbitrumComplianceNote,
  setAcceptedComplianceNote,
}) => {
  const [checkedCompliance, setCheckedCompliance] = useState(false)

  return (
    <GenericModal
      footer={
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={4}
          width="full"
        >
          <Button
            colorScheme="gray"
            variant="outline"
            onClick={() => {
              setDisplayArbitrumComplianceNote(false)
              setCheckedCompliance(false)
            }}
          >
            Cancel
          </Button>
          <Button
            isDisabled={!checkedCompliance}
            variant="primary"
            onClick={() => {
              setAcceptedComplianceNote(true)
              setDisplayArbitrumComplianceNote(false)
              setCheckedCompliance(false)
            }}
          >
            Continue
          </Button>
        </Stack>
      }
      height="auto"
      isOpen={displayArbitrumComplianceNote}
      maxWidth="460px"
      mt="64px"
      mx="12px"
      title="Compliance note"
      top={{ base: "unset", lg: "120px" }}
      onClose={() => {
        setDisplayArbitrumComplianceNote(false)
        setCheckedCompliance(false)
      }}
    >
      <Stack>
        <Text>
          For a proposal that spends DAO funds, we recommend reaching out to the
          Arbitrum Foundation about compliance-related matters.{" "}
        </Text>

        <Text>
          Email:{" "}
          <Link
            isExternal
            color="#5091EF"
            href="mailto:compliance@arbitrum.foundation"
          >
            compliance@arbitrum.foundation
          </Link>
        </Text>

        <Checkbox
          colorScheme="purple"
          isChecked={checkedCompliance}
          onChange={() => {
            setCheckedCompliance(!checkedCompliance)
          }}
        >
          I have reached out to the Arbitrum Foundation
        </Checkbox>
      </Stack>
    </GenericModal>
  )
}

export default ArbitrumComplianceNoteModal
